export default {
    // 通用数据
    generalData: {
        date: "date",
        modifyTime: "modify",
        searchTips: "Enter search keywords",
        name: "name",
        submitTime: "submit time",
        startTime: "start time",
        endTime: "end time",
        selectDate: "select date",
        startDate: 'start date',
        endDate: 'end date',
        submitter: "submitter",
        status: "status",
        type: "type",
        operation: "operation",
        none: "none",
        total: "total",
        lastWeek: "Last week",
        lastMonth: "Last month",
        theLastThreeMonths: "The last three months",
        prompt: "prompt",
        time: "time",
        rateOfChange: "rate of change",
        other: "other",
        aTotalOf: "a total of",
        records: "records",
        image: "image",
        video: "video",
        text: "text",
        script: "script",
        rate: "rate",
        open: 'open',
        noOpen: 'no open',
        close: 'close',
        high: "high",
        low: "low",
        determine: "determine",
        custom: 'customize',
        unlimited: 'unlimited',
        set: 'set',
        sets: 'sets',
        detail: 'detail',
        percentage:'percentage',
        item: 'item',
        yuan: 'RMB',
        second: 'second',
        instance: 'Sample template',
        quantity: 'quantity',
        import: 'import',
        enter: 'please enter',
        required: 'required',
        optional: 'optional',
        export: 'export',
        textCount: 'text count',
        folder: 'folder',
        target: 'target',
        currentDir: 'current directory',
        rootDir: 'root directory',
        warning: {
            saveError: "Save failed, please try again",
            loadFail: "Failed to load, Please try again",
            synchronizeFail: "Synchronization failed, please try again",
            operationFail: "Operation failed, please try again",
            notSupport: 'view not supported',
            editFail: 'edit failed',
            tryAgain: 'failed, please try again',
            pushing: 'Pushing, please refresh the list query results',
            pushFail: 'push failed',
        },
        success: {
            saveSuccess: "Saved successfully!",
            submitSuccess: "Submitted successfully!",
            synchronizeSuccess: "Synchronization is complete!",
            removeSuccess: "Successfully deleted!",
            setSuccess: 'successfully set',
            createSuccess: 'created successfully',
            editSuccess: 'edit successfully',
            freezeSuccess: 'freeze successfully',
            unfreezeSuccess: 'unfreeze successfully',
            pushSuccess: 'push successfully',
        },
        placeholder: {
            pleaseChoose: "Please choose",
            pleaseEnter: "Please enter",
            pleaseSearch: "Enter to search",
            all: "all",
            enter: 'please enter content',
            userName: 'please enter user name',
            customer: 'Please enter customer name',
        },
        select: {
            optional: "optional",
            selectAll: "select all",
            selected: "selected",
            empty: "empty",
            isSelected: "is selected",
            chosen: 'chosen'
        },
        range: {
            greater: "greater",
            smaller: "smaller",
            between: "between",
            eq: 'equal',
            lt: 'less than',
            gt: 'greater than',
        },
        confirm:{
            delete:"Delete the selected data?",
            tag:"Are you sure to delete this label?",
            enable: 'Are you sure to enable',
            disable: 'Are you sure to disable'
        }
    },
    //状态
    mkpStatus: {
        waitingForEdit: 'waitingForEdit',
        editing: 'editing',
        waitingForConfig: 'waitingForConfig',
        submitting: 'submitting',
        success: 'success',
        fail: 'fail',
        waitingUpdate: 'waitingUpdate'
    },
    btns: {
        confirm: 'confirm',
        cancel: 'cancel',
        delete: "delete",
        add: "add",
        upload: "upload",
        edit: "edit",
        download: "download",
        history: "history",
        send: "send",
        synchronizing: "synchronizing",
        synchronize: "synchronize",
        select: "select",
        application: "application",
        search: "search",
        clearAll: "clear all",
        submit: 'submit',
        clear: 'clear',
        new: "new",
        back: 'back',
        addTo: "add to",

        replace: "replace",
        edit2: "edit",
        addEnter: 'add(enter key)',
        save: "save",
        filter: "filter",
        reset: "reset",

        detail: 'detail',
        view: 'view',
        share: 'share',
        assign: 'assign',

        reservation:"reservation",
        freeze: 'freeze',
        copy: 'copy',
        unfreeze: 'unfreeze',
        play:"play",
        preview:"preview",
        close: 'close',
        jump:"jump",
        push: 'push',//推送
        enable: 'enable',//启用
        disable: 'disable',//停用
        pushLog: 'log',//推送记录
        bind: 'bind',
        save: 'save'
    },
    //侧边栏
    sideBar: {
        creative: {
            creative: 'Promotion',//推广
            campaign: 'Campaign',//广告组
            campaignNew: 'Create Campaign',//广告组创建
            materialManager: 'Material',//素材管理
            historicalMaterial: 'Historical Material', // 历史素材
            setLabel: 'Set Label',//编辑标签
            creativeManager: 'Creative',//创意管理
            creativeNew: 'Creative New',//创建创意
            creativeDetail: 'Creative Detail',//创意详情
            planList: 'Plan',//计划管理
            planNew: 'Plan New',//计划创建
            planDeploy: 'Plan Deploy',//计划配置
            planEdit: 'Plan Edit',//编辑
            planBulkEdit: 'PlanBulk Edit'//批量设置信息
        },
        empower: {
            empower: 'Empower',//创意赋能
            demand: 'Demand',//需求管理
            material: {
                material: 'Material Library',//素材库
                picture: 'Picture',//图片库
                video: 'Video',//视频库
                script: 'Script', // 脚本库
                text: 'Text',//文案库
                script: 'Script',//脚本库
                webpage: 'Webpage',//落地页
                data: 'Customer file',//客户文件
            },
            template: {
                template: 'Template Library', // 模板库
                text: 'Text', // 文案
                design: 'Design', // 图片
                video: 'Video', // 视频
            },
            materialData: 'Material data',//素材数据
            mediaManage: 'Media management',//媒体管理
            materialSet: 'Material settings',//素材设置
            actor: 'Actor Library',//演员库,
            resources:"Resources Library"
        },
        data: {
            data: 'Report',//数据中心
            advertiser: {
                advertiser: 'Advertiser',//广告报表
                accountReport: 'Account Report',//账户报表
                campaignReport: 'Campaign Report',//广告组报表
                planReport: 'Plan Report',//广告计划报表
                creativeReport: 'Creative Report'//广告创意报表
            },
            summary: {
                summary: 'AccountReport' //客户报表
            },
            menu: {
                menu: 'Material label report' //素材标签报表
            },
						live: {
							live: 'Live Report', // 直播报表
						},
            audience: {
                audience: 'Audience',//受众分析
                advertiserAudience: 'Advertiser Audience',//账户受众
                campaignAudience: 'Campaign Audience',//广告组受众
                planAudience: 'Plan Audience',//广告计划受众
                creativeAudience: 'Creative Audience'//广告创意受众
            },
            product: {
                product: 'Product',//广告产品
                creativeProductReport: 'Creative Report',//程序化创意
                materialReport: 'Material Report',//分素材统计
                materialCount: 'Material Count',//素材量统计
                tagStat: 'Tag Statistics'//标签统计
            }
        },
        secondWeb: {
            secondWeb: 'Second Web Material',//二网素材
            video: 'Video',//视频库
        },
        tiktok: {
            tiktok: 'TikTok',
            audience: {
                audience: 'Audience',
                campaign: 'Campaign',
                adgroup: 'AdGroup',
                ad: "Ad"
            }
        },
        
        my:{
            my:"my",
            myApplication:"my application",
            myApproval:"my approval"
        },
        safety: {
            safety: 'Safety',//安全
            permission: 'Permission',//用户权限
            log: 'Log',//操作日志
            authorize: 'Second Web Authorize',//二网授权
        },
        set: {
            set: 'Settings',//设置
            label: 'Label',//标签
            adr: 'Adr',//账户管理
            media: 'Media',
            materialType: 'Material type',
            materialRule: 'Material rule',
            mediaManage: 'Media management',//媒体管理
            materialSet: 'Material settings',//素材设置
            carModel: 'Model management ',//车型管理
            scoreSet: 'Score set', // 评分设置
            copywriting: 'Copywriting set', // 文案句式管理
            templateIcon: 'templateIcon set', // 模板库标签
        },
        materialLibrary: 'Material Library',
        mediaScore: 'Media Score',
        mediaWeightedScore: 'Media Weighted Score',
        manageBoard: 'Management Board',
        personalBoard: 'Personal Board',
        personalBoardNew: 'Personal Board',
        automaticReport: 'Automatic Report',
        transform: {
            transform: 'Transform Clue',
            transformHistory: 'Transform History'
        }
    },
    login: {
        username: 'username',
        password: 'password',
        signin: 'signin',
        remember: 'remember the user name and password',
        wechat:"WeChat scan code login",
        loading:"The QR code is loading. . ."
    },
    // 素材库
    materialLibrary: {
        label: {
            associatedGroup: 'Related group',
            uploadToutiao: 'Upload toutiao',
            group: 'group',
            specificationType:'specification type'
        },
        message:{
            sendSuccess:'Push successfully',
            relatedSuccess:'Related successfully',
            uploading:'uploading...',
        }
    },
    // 线索转发
    transform:{
        label:{
            token:'token',
            project:'project',
            secret: 'secret', // 密钥
            name: 'name', // 名称
            client: 'client', // 客户
            clueName: 'clueName', // 项目名称
            clueType: 'clueType', // 线索类型
            director: 'director', // 负责人
            externalUrl: 'externalUrl', // 落地页
            isSend: 'isSend', // 是否下发
            source: 'source', // 渠道来源
            toutiaoSecret: 'toutiaoSecret', // 头条密钥
            toutiaoToken: 'toutiaoToken', // 头条token
            dealer: 'dealer',
            series: 'series',
            smartCode: 'smartCode',
            status: 'status',
        },
        placeholder: {
            token: 'Please enter the token',
            name: 'Please enter the name',
            secret: 'Please enter the secret',
            client: 'Please enter the client',
            appId: 'Please enter the appId',
            clueName: 'Please enter the clueName',
            appSecret: 'Please enter the appSecret',
            clueType: 'Please select the clueType',
            director: 'Please enter the director',
            externalUrl: 'Please enter the externalUrl',
            id: 'Please enter the id',
            isSend: 'Please select the isSend',
            pageId: 'Please enter the pageId',
            smartCode: 'Please enter the smartCode',
            source: "Please enter the source",
            accessSecretId: "Please select the accessSecretId",
            dealer: 'Please enter the dealer',
            series: 'Please enter the series',
            smartCode: 'Please enter the smartCode',
            toutiaoSecret: 'Please enter the toutiaoSecret',
            toutiaoToken: 'Please enter the toutiaoToken',
            startDate:'start time',
            endDate:'end time'
        },
        button: {
            create: 'create',
            back: 'back',
            exportDealer: 'export dealer',
            exportModel: 'export model',
            exportAllDealer: 'export all dealer'
        },
        title: {
            retry: 'retry',
            detail: 'detail',
        },
        historyLabel:{
            dealer: 'dealer', // 经销商名称
            series: 'series', // 车系名称
            gmtCreate: 'synchronis time', // 记录同步时间
            cluesId: 'cluesId', // 头条线索Id
            clueIds: 'clueIds', // 车巴巴线索Id
            externalUrl: 'externalUrl', // 落地页
            clueType: 'clueType', // 线索类型
            isSend: 'isSend', // 是否下发
            source: 'source', // 渠道来源
            storeCodes: 'storeCodes', // 店铺编码
            name: 'name', // 姓名
            telphone: 'telphone', // 电话
            syncMsg: 'status', // 转发状态
            msg: 'error message', // 错误信息
            otherInfo: 'other message', // 其他信息
        },
        action:{
            edit: 'edit',
            delete: 'delete',
            history: 'transform history',
            openUrl: 'open externalUrl',
            deactivate: 'deactivate'
        },
        message: {
            createSucceed: 'create success!',
            editSucceed: 'edit success!',
            delete: 'Are you sure to delete this record?',
            export: 'Exporting...'
        },
    },
    // 客户报表
    summary: {
        message: {
            confirm: 'Confirm to delete the template？',
            name: 'Please fill in the template name',
            edit: 'The sent file does not support modification',
            refresh: 'Please refresh and try again',
            upload: 'Sent file does not support upload',
            uploadSize: 'The upload file size cannot exceed 500MB!',
            delete: 'Sent file does not support deletion',
            file: 'File',
            uploadSuccess: 'Upload successfully!',
            uploadFail: 'Upload failed! Please try again',
            selectOne: 'Table, select at least one base data item',
            selectTwo: 'For a composite chart, you must select 2 basic data items',
            pageErr: 'Page Numbers must be greater than 1',
            pageRepeat: 'Page Numbers cannot be repeated',
            modelEmpty: 'The model list is empty, please select another account',//车型列表为空，请选择其他账号
            formatError: 'Please upload excel file',//请上传excel文件
            sizeError: 'File size cannot exceed 2M',//文件大小不能超过2M
            complexErr: 'For composite chart, 2 basic data must be selected',//复合型图表，必须选择2个基础数据
        },
        form: {
            reportType: "report type",
            reportStatus: "report status",
            title: "Enter template name",
            templateName: "template name",
            history: "history",
            upload: "File Upload",
            dropFiles: "Drag the file here, or ",
            clickToUpload: "click to upload",
            uploadWarning: "The size does not exceed 500MB",
        },
        selectData: {
            daily: "daily report",
            weekly: "weekly report",
            monthlyReport: "monthly report",
            summary: "summary",
            whole: "whole",
            generating: "generating",
            buildFailed: "build failed",
            generated: "generated",
            downloaded: "downloaded",
            adjusted: "adjusted",
            hasBeenSent: "has been sent",

            none: "none",
            total: "total",
            audienceAnalysis: "audience analysis",
            creativeAnalysis: "creative analysis",
            platformComparison: "platform comparison",
            materialStatistics: "material statistics",
            landingPageAnalysis: "landingPage analysis",

            day: "day",
            week: "week",
            month: "month",

            account: "account",
            adGroup: "ad group",
            segmentationList: {
                INVENTORY: "placement",
                ADVERTISER_ID: "account number",
                PROVINCE_NAME: "province",
                CITY_NAME: "city",
                AGE: "age",
                GENDER: "gender",
                AD_TAG: "interest",
                INTEREST_TAG: "Keywords of interest",
                TOP5_CREATIVE: "TOP5 consumes and low-cost materials",
                CREATIVE_TAG: "Proportion of creative labels",
                MATERIAL_INFO_PER: "Consumption of material types & comparison of retention costs",
                PLATFORM: "Comparison of consumption & retention costs of the four major platforms",
                PROJECT_MATERIAL: "Statistics of cumulative delivery material during the project period",
                GOOD_CREATIVE: "Quality Creativity Statistics",
                POOR_CREATIVE: "Poor creative statistics",
            }

        },
        model: {
            generateReports: "generate reports",
            editReport: "edit report",
            reportName: "report name",
            parameterTemplate: "parameter template",
            reportType: "report type",
            outputFormat: "output format",
            dataDimension: "data dimension",
            customerAccount: "customer account",
            timeBreakdown: "time breakdown",
            granularityBreakdown: "granularity breakdown",
            basicData: "basic data",
            selectAll: "select all",
            consumption: "consumption",
            impressions: "impressions",
            traffic: "traffic",
            conversionVolume: "conversion volume",
            projectName: "project name",
            segmentData: "segment data",
            kpi: "KPI",
            pageNo: "pageNo",
            parameters: "parameters",
            format: "format",
            excelTemplate: 'sort template',
        },
        button: {
            saveAsTemplate: "save as template",
            upLoadTemplate: 'Upload an Excel sort template',//上传Excel排序模板
        },
        placeholder: {
            reportType: "Please select a report type",
            reportStatus: "Please select report status",
            templateInfo: "Please select a parameter template",
            fileType: "Please select the output format",
            idType: "Please select a data dimension",
            segmentationType: "Please select granular breakdown",
            segmentation: "Please select the data to be segmented",
            addReport: "Please add the report first",
            keyword: 'Please enter the report name',//请输入报表名称
        },
        rules: {
            reportName: "Please enter a name",
            reportNameLong: "1 to 50 characters in length",
            advertiserIds: "Please select a customer account",
            campaignIds: "Please select an ad group",
            dateRange: "Please select a date",
            projectName: "Please enter a project name",
            projectNameLong: "1 to 50 characters in length",
            kpi: "Please enter the KPI",
            kpiNumber: "Kpis must be Numbers",
            carModelIds: 'Please select a model',//请选择车型
            templateUid: 'Please upload excel template',//请上传excel模板
        },
        delete: {
            title: "Confirm to delete the report?"
        },
        hisColumn: {
            fileName: "file name",
            gmtCreate: "submit time",
            creator: "submitter",
            fileType: "file type",
            download: "download",
        }
    },
    // 图形呈现格式
    chartType: {
        showType: "show type",
        table: "table",
        histogram: "histogram",
        barGraph: "bar graph",
        lineVhart: "line vhart",
        pieVhart: "pie vhart",
        compound: "compound",
    },
    //创意中心
    creative: {
        //素材管理
        material: {
            title: "Recommended cover",
            label: {
                brandTag:"the brand tag",
                carBrand: 'car brand',
                carModelTags: "car model tags",
                brandTags: "brand tags",
                policyTags: "policy tags",
                contentTags: "content tags",
                customizeTags: "customize tags", // 自定义标签
                changeTime: "change the time",
                materialType: "material type",
                SpecificationType: "specification material type",
                name: "name",
                tags: "tags",
                comments: "remarks",
                material: "material",
                image: "image",
                video: "video",
                text: "text",
                brand: "brand",
                feedback:"feedback",
                myMaterial:"My material",
                localUpload:"Local Upload",
                group: 'group', 
                member: 'member',
                editGroup: "Edit group", // 编辑负责人
                groupDetail: "Group detail", // 人员详情
                account: "account"
            },
            message: {
                error: "The label is not completed yet!",
                success: "Successfully modified",
                validatePolicyAndBrand: "Please set a brand label or policy label",
                validatePolicyOrBrand: "Brand label and policy label can only choose one",
                imageError: "Please select a picture",
                tagAPi: "The label is set successfully!",
                addMaterial: "Created successfully",
                handleUploadError: "Failed, please try again",
                editSuccess: "Edit successfully",
                editFail: "Edit failed",
                fileLimit: "File size cannot exceed 10MB",

                uploadImgSize: "Suggested best: aspect ratio 9:16, 720*1280≤size≤1440*2560, support JPG, PNG and other image formats",
                imgLength: "Image size does not match video size",
                imgFormat: 'Please upload JPG, PNG and other pictures',
                imgCover: "Please select or upload a cover image",
                updateSuccess: "update completed",
                noData:"No data",
                fileMsg: "Only excel files can be uploaded, and no more than 10MB",
            },
            radioLabelList: {
                image1: "Picture element",
                image2: "the color of car",
                video1: "Video type",
                video2: "Video style",
                text1: "Dynamic word pack",
                text2: "Field length",
            },
            // tmp:{
            //     text1:"Dynamic word pack",
            //     text2:"Field length",
            //     video1:"Video type",
            //     video2:"Video style",
            //     image1:"Picture element",
            //     image2:"the color of car",
            // },
            btns: {
                setLabel: "Set label",
                exportTemplate: "Export template",
                downLabelTpl: "Download template",
                importMaterial: "Import material",
                importTags:"Batch import tags",
                editTags: "Edit tags",
                editMaterial: "Edit material",
                upload: "Local Upload",
                finish: "Finish",
                batch: "Batch Upload",
            },
            placeholder: {
                carModelTags: "Please select the brand name",
                brandTagIds: "Please select a brand label",
                policyTagIds: "Please select a policy label",
                all: "All",
                carModel: "Please select a model",
                brand: "Please select a brand",
                customizeTag: "Please select the customize label", //请选择自定义标签
            },
            dynamicColum: {
                image: {
                    id: "Image ID",
                    name: "Picture name",
                    url: "Image",
                    type: "Material type",
                    toutiaoType: "Specification Material type",
                    MRType: "MR Material type",
                    demandName: "demand Name"
                },
                video: {
                    id: "Video ID",
                    name: "Video name",
                    url: "video",
                    coverUrl: "cover picture",
                    type: "Material type",
                    toutiaoType: "Specification Material type",
                    MRType: "MR Material type"
                },
                text: {
                    id: "Copy ID",
                    name: "Copy name",
                    content: "Copywriting content",
                    text: "word count",
                },
            },
            downLabelTmpl: "Copy Label template",
            downTmpl: "Copy material template",
            selectedPerson: "Selected",
            deleteSeleted: "members"
        },
        //创意管理
        creative: {
            //创意列表
            creativeList: {
                //表单
                queryCriteria: {
                    creativeMode: 'mode',
                    statue: 'status',
                },
                placeholder: {
                    searchValue: 'creative id/creative name/creative title',
                },
                status: {
                    online: 'online',
                    notOnline: 'not online'
                },
                mkpCreativeMode: {
                    programmaticCreativity: 'programmatic creativity',
                    customCreative: 'custom creative'
                },
                button: {
                    createCreative: 'create creative',
                    exportCreative: 'export creative',
                    view: 'view'
                },
                //报表列
                column: {
                    id: 'creative id',
                    mkpCreativeName: 'creative name',
                    mkpCreativeContent: 'creative content',
                    mkpCreativeTitle: 'creative title',
                    mkpCreativeMode: 'creative mode',
                    mkpCreativeNum: 'creative number',
                    status: 'creative status',
                    gmtModified: 'modify time',
                    operating: 'operating'
                }
            },
            creativeDetail: {
                ruleForm: {
                    mkpCreativeId: 'creative id',
                    mkpCreativeName: 'creative name',
                    article: 'article',
                    image: 'image',
                    video: 'video',
                    creativeTitle: 'creative title',
                    creativeContent: 'creative content'
                }
            },
            creativeNew: {
                label: {
                    creativeMode: 'creative mode',
                    creativeNum: 'creative number',
                    creative: 'creative',
                    materialType: 'material type',
                    creativeContent: 'creative content',
                    creativeTitle: 'creative title',
                    creative_text: 'choose text',
                    creative_pic: 'choose pictures',
                    creative_video: 'choose video',
                    creativeName: 'creative name',
                    picNumber: 'number of creative pictures',
                    videoNumber: 'number of video ideas',
                    textNumber: 'number of copy',
                    least_text_pic_video: 'please select at least one copy and at least one picture or video',
                    fill_information: 'for custom ideas, please fill in the complete information',
                    generate: 'will generate',
                    creatives: 'creatives',
                    selectOne: 'please select an idea'
                },
                placeholder: {
                    enter: 'please enter the picture ID/name/tag/remark',
                },
                btns: {
                    addCreative: 'add creative'
                },
                error: {
                    mast: 'add up to 10 custom ideas',
                },
                column: {
                    imageId: 'iamge id',
                    imageName: 'image name',
                    imageUrl: 'image url',
                    materialType: 'material type',
                    modelLabel: 'brand name',
                    brandLabel: 'brand label',
                    policyLabel: 'policy label',
                    contentLabel: 'content label',
                    remarks: 'remarks',

                    videoId: 'video id',
                    videoName: 'video name',
                    videoUrl: 'video url',
                    coverUrl: 'cover url',

                    text: 'text',
                    textId: 'text id',
                    textTitle: 'text title',
                    textContent: 'text content',
                }
            }
        },
        //计划管理
        plan: {
            planList: {
                exportForm: "Plan list",
                // 信息
                message: {
                    noError: "No error message",
                    planError: "Please select a plan",
                    msgError: "Please tick the plan to be configured, successful submission, failed submission, and status to be updated for configuration"
                },
                //表单
                queryCriteria: {
                    mkpStatus: 'status',
                },
                placeholder: {
                    all: 'all',
                    start: 'startDate',
                    end: 'endDate',
                    keyword: 'plan id/advertising plan name/clients name/brand'
                },
                button: {
                    createPlan: 'create plan',
                    exportPlan: 'export plan',
                    importPlan: 'import plan',
                    setPlan: 'set plan',
                    setCreative: 'set creative',
                    setPrice: 'set price',
                    batchSetting: 'batch setting',
                    view: 'view',
                    edit: 'edit',
                    setting: 'configuration',
                    retry: 'retry',
                    clear: 'clear'
                },
                //报表列
                column: {
                    ac: "internet",
                    id: 'plan id',
                    name: 'plan name',
                    status: 'status',
                    mkpCreativeMode: 'creative mode',
                    adNum: 'creative number',
                    inventoryType: 'ad placement',
                    materialAddWay: 'how to add materials',
                    source: 'source',
                    advancedCreativeType: 'additional creative types',
                    buttonText: 'call to action',
                    creativeDisplayMode: 'convert any material to video',
                    generateDerivedAd: 'best Creative Derivative Plan',
                    isCommentDisable: 'ad review',
                    creativeDisplayMode: 'creative display',
                    thirdIndustryName: 'creative classification',
                    adKeywords: 'creative label',
                    trackUrl: 'display monitoring',
                    actionTrackUrl: 'click to monitor',
                    videoPlayTrackUrl: 'video play monitoring',
                    videoPlayDoneTrackUrl: 'Video playback monitoring',
                    videoPlayEffectiveTrackUrl: 'video effective playback monitoring',
                    deliveryRange: 'delivery range',
                    deliveryTargetStr: 'delivery target',
                    deliveryContent: 'serve content',
                    externalUrl: 'landing page link',
                    convertTargetStr: 'conversion goal',
                    openUrl: 'direct link',
                    city: 'city',
                    genderStr: 'gender',
                    ageStr: 'age',
                    mkpCustomeTags: 'custom crowd',
                    interestActionMode: 'behavioral interest',
                    mkpAweme: 'tiktok intelligent person',
                    superiorPopularityType: 'featured traffic packages',
                    platform: 'platform',
                    autoExtendEnabled: 'smart volume',
                    articleCategory: 'article classification',
                    carrier: 'carrier',
                    activateTypeStr: 'new user',
                    deviceBrand: 'device brands',
                    launchPrice: 'device price',
                    smartBidTypeStr: 'bid method',
                    flowControlModeStr: 'delivery method',
                    budget: 'budget',
                    scheduleTypeStr: 'delivery time',
                    deliveryPeriod: 'delivery period',
                    pricingStr: 'payment methods',
                    cpaBid: 'target conversion bid',
                    hideIfConvertedStr: 'filter converted users',
                    gmtModified: 'modify time',
                    operating: 'operating'
                }
            },
            planEdit: {
                tab: {
                    creative: 'creative information',
                    plan: 'plan information',
                    bid: 'budget and bid'
                },
                placeholder: {
                    groupName: 'please enter a creative group name',
                    inventoryTypes: 'please select an advertising location',
                    source: 'please enter source',
                    creativeDisplayMode: 'please select a display format',
                    toutiaoThirdIndustryId: 'please select creative category',
                    adKeywords: 'please create a creative label',
                    trackUrl: 'please enter display monitoring',
                    actionTrackUrl: 'please enter click to monitor',
                    videoPlayTrackUrl: 'please enter the video playback monitoring',
                    videoPlayDoneTrackUrl: 'please enter the end of the video to monitor',
                    videoPlayEffectiveTrackUrl: 'please enter effective video monitoring',

                    deliveryTarget: 'please select a delivery goal',
                    convertTarget: 'please select a conversion goal',
                    gender: 'gender',
                    age: 'age',
                    customCrowdType: 'please select a custom crowd',
                    retargetingTagsInclude: 'enter the crowd package ID, separated by multiple ID spaces, no more than 10',
                    actionScene: 'all behavior scenarios',
                    interestActionMode: 'please select behavioral interest',
                    behaviorCategoryWords: 'please enter behavior category words',
                    awemeMode: 'please select tiktok author',
                    awemeRemoteMethod: 'support searching the category of Douyin Daren, Douyin Nickname or Douyin Daren',
                    tiktokAuthors: 'tiktok authors',
                    tiktokCategories: 'tiktok categories',
                    addAuthorCategories: 'add authors categories',
                    addTiktokAuthor: 'add tiktok author',
                    authorCategories: 'author categories',
                    awemeFanBehaviors: 'please select tiktok author behavior',
                    superiorPopularityType: 'please select featured traffic packages',
                    province: 'province',
                    city: 'city',
                    in: 'in',
                    select: ', select users',
                    happen: 'behaviors that occurred within days',
                    unlimited: 'unlimited',
                    choosePlatform: 'choose platform',

                    smartBidType: 'please select a bidding method',
                    flowControlMode: 'please select a delivery method',
                    budget: 'please enter a budget',
                    pricing: 'please select payment method',
                    cpaBid: 'please enter a target conversion bid',
                    hideIfConverted: 'Please select filtered users',

                    creativeGroup: 'please select creative information group',
                    addCreativeGroup: 'choose Creative Information Group',

                    creativeGroupName: 'please select creative information group name'
                },
                ruleForm: {
                    adKeywords: 'up to 20 tags, each not exceeding 10 words, can be separated by spaces',
                    customCrowdType: 'please select a custom crowd',
                    interestActionMode: 'please select behavioral interest',
                },
                error: {
                    packages: 'crowd packages overlap',
                    authors: 'no more than 30 tiktok authors',
                    interest: 'no more than 350 interests',
                    action: 'no more than 350 acts',
                    least: 'choose at least on tiktok author action'
                },
                genderList: {
                    female: 'female',
                    male: 'male',
                    none: 'unlimited'
                },
                convertTargetList: {
                    form: 'form submission',
                    customer: 'effective customer acquisition'
                },
                deliveryTargetList: {
                    click: 'clicks',
                    transform: 'inversion quantity',
                    exposure: 'impressions'
                },
                customCrowdTypeList: {
                    none: 'unlimited',
                    custom: 'custom crowd'
                },
                interestActionModeList: {
                    none: 'unlimited',
                    recommend: 'system recommendation',
                    custom: 'customize'
                },
                superiorPopularityTypeList: {
                    none: 'unlimited',
                    app: 'application software selection',
                    game: 'game Selection'
                },
                actionSceneList: {
                    e_commerce: 'E-commerce behavior scene',
                    news: 'Information Behavior Scene',
                    app: 'App Behavior Scene'
                },
                awemeModeList: {
                    none: 'unlimited',
                    custom: 'customize'
                },
                awemeBehaviorsList: {
                    followed_user: 'followed users',
                    commented_user: 'rated users within 15 days',
                    liked_user: 'liked users in 15 days',
                    shared_user: 'shared users in 15 days'
                },
                creativeDisplayModeList: {
                    preferred_mode: 'preferred mode',
                    carousel_mode: 'carousel mode'
                },
                inventoryTypesList: {
                    toupiao: 'toupiao information flow',
                    xigua: 'xigua information flow',
                    hotsoon: 'hotsoon information flow',
                    tiktok: 'tiktok information flow'
                },
                form: {
                    planId: 'plan id',
                    groupName: 'creative group name',
                    inventoryTypes: 'ad placement',
                    source: 'source',
                    creativeDisplayMode: 'form of presentation',
                    toutiaoThirdIndustryId: 'creative classification',
                    adKeywords: 'creative label',
                    trackUrl: 'display monitoring',
                    actionTrackUrl: 'click to monitor',
                    videoPlayTrackUrl: 'video playback monitoring',
                    videoPlayDoneTrackUrl: 'video broadcast monitoring',
                    videoPlayEffectiveTrackUrl: 'video effective playback monitoring',

                    planGroupName: 'plan group name',
                    deliveryTarget: 'delivery target',
                    externalUrl: 'landing page link',
                    convertTarget: 'conversion goal',
                    regions: 'regions',
                    gender: 'gender',
                    age: 'age',
                    customCrowdType: 'custom crowd',
                    retargetingTagsInclude: 'orientation',
                    exclude: 'exclude',
                    interestActionMode: 'behavioral interest',
                    action: 'action',
                    interest: 'interest',
                    awemeMode: 'tiktok author',
                    superiorPopularityType: 'featured traffic packages',
                    platform: 'platform',
                    behaviorCategory: 'add category words',
                    behaviorCategoryWords: 'add keywords',
                    actionCategoriesNode: 'headword',
                    actionWords: 'keywords',

                    smartBidType: 'bid method',
                    flowControlMode: 'delivery method',
                    budget: 'budget',
                    pricing: 'payment methods',
                    cpaBid: 'target conversion bid',
                    hideIfConverted: 'filter converted users',
                },
                budgetModeList: {
                    budgetModeDay: 'daily budget',
                    budgetModeTotal: 'total budget'
                },
                flowControlModeList: {
                    flowControlModeFast: 'priority run',
                    flowControlModeSmooth: 'priority low cost',
                    flowControlModeBalance: 'balanced delivery'
                },
                smartBidTypeList: {
                    smartBidCustom: 'manual',
                    smartBidConservative: 'automatic'
                },
                hideIfConvertedList: {
                    noExclude: 'no filtering',
                    ad: 'advertising plan',
                    campaing: 'ad group',
                    advertiser: 'advertising account',
                    app: 'APP',
                    customer: 'company account',
                    budgetModeTotal: 'total budget'
                },
                flowControlModeList: {
                    flowControlModeFast: 'priority run',
                    flowControlModeSmooth: 'priority low cost',
                    flowControlModeBalance: 'balanced delivery'
                },
                smartBidTypeList: {
                    smartBidCustom: 'manual',
                    smartBidConservative: 'automatic'
                },
                hideIfConvertedList: {
                    noExclude: 'no filtering',
                    ad: 'advertising plan',
                    campaing: 'ad group',
                    advertiser: 'advertising account',
                    app: 'APP',
                    customer: 'company account'
                }
            },
            planDeploy: {
                ruleForm: {
                    planGroup: 'planning group',
                    planId: 'plan id',
                    planName: 'plan name',
                    adNum: 'ad number',
                    adGroup: 'configure ad group',
                },
                column: {
                    advertiserName: 'advertiser name',
                    campaignName: 'campaign name',
                    adId: 'ad id',
                    touTiaoAdName: 'ad name'
                },
                placeholder: {
                    search: 'search'
                },
                title: {
                    advertiser: 'advertiser',
                    campaign: 'campaign',
                    attention: 'attention',
                    isUpdate: 'the following plan is in the running state, are you sure to update'
                },
                message: {
                    campaign: 'please select ad group',
                    success: 'successfully configured'
                }
            },
            planNew: {
                ruleForm: {
                    adCreateType: 'create type',
                    mkpCreativeMode: 'creative mode',
                    adCreateType0: 'create plans in bulk',
                    adCreateType1: 'create a single plan',
                    mkpCreativeMode0: 'custom creative',
                    mkpCreativeMode1: 'programmatic creativity',
                    chooseCreative: 'choose creative'
                },
                rule: {
                    chooseOne: 'please select at least one'
                },
                label: {
                    modelLabel: 'brand name',
                    brandLabel: 'brand label',
                    policyLabel: 'policy label',
                    contentLabel: 'content label',
                    enterContent: 'Creative ID/Creative Name/Label',
                    chosen: 'chosen'
                },
                column: {
                    id: 'creative id',
                    mkpCreativeName: 'creative name',
                    mkpCreativeContent: 'creative content',
                    mkpCreativeTitle: 'creative title',
                    carModelTags: 'car mode tags',
                    brandTags: 'brand tags',
                    policyTags: 'policy tags',
                    contentTag: 'content tag'
                }
            },
            setPlanForm: {
                planType: {
                    chooseGroup: 'select plan information group',
                    addGroup: 'new plan information group'
                },
                ruleForm: {
                    directional: 'directional crowd pack',
                    exclude: 'exclude crowd pack',
                    headword: 'headword',
                    keyword: 'keyword',
                    classify: 'talent classification',
                    tiktok: 'tiktok author'
                }
            }
        }
    },
    //用户权限
    permission: {
        title: "Modify permissions",
        column: {
            username: "username",
            editPermissions: "edit permissions",
            bingSecondWeb: 'bind second web user',//关联二网用户
            userList:"user list",
            roleList:"role list",
            group:"Related operations"
        }
    },
    // 操作日志
    log: {
        filterForm: {
            operatingRange: "operating range",
            operationContent: "operation content",
            unlimited: "unlimited"
        },
        placeholder: {
            range: "Please select operating range",
            content: "Please select operation content",

        },
        column: {
            module: "Operation object type",
            name: "Operation object name",
            description: "Operation content",
            userName: "Operator",
            gmtCreate: "Operating time",
        }
    },
    // 账户管理
    adr: {
        form: {
            name: "client's name",
            advertiserIds: "subordinate account",
        },
        removeClient: 'Confirm to delete this customer?'
    },
    // 广告组选择组件
    adSelector: {
        title: "Select ad group",
        title2: 'Select Campaign',
        selected: "selected",
        item: "items",
        chooseAccount: "Please select an account first",
        campaign: "Campaign",
        adGroup: "Ad group",
        adPlan: "Advertising plan",
        adCreative: "Advertising creative",
    },
    // 数据中心
    dataCenter: {
        publicData: {
            account: "account",
            hours: "hours",
            day: "day",
            weeks: "weeks",
            months: "months",
            total: "total",
            filter: "filter",
            reset: "reset",
            collapse: "collapse",
            unfold: "unfold",
            downloadForm: "download form",
            compare: "compare"
        },
        // 广告报表
        report: {
            campaign: {
                landingTypeOptions: {
                    link: "Lead collection",
                    app: "Application promotion",
                    dpa: "Product catalog promotion",
                    goods: "Product Promotion (Luban)",
                    store: "Store promotion",
                    aweme: "Douyin Promotion",
                    shop: "E-commerce store promotion",
                }
            }
        },
        // 素材标签报表
        menu: {
            dialog: {
                dimension: "Dimension", // 维度
                level: "Level", // 层级
                title: "chart" // 图表
            },
            form: {
                customizeTag: "customize tag", // 自定义标签
                type: "type" // 类型
            },
            index: {
                tagName: "tag name",
                cost: "cost",
                show: "show",
                avgShowCost: "avg show cost",
                click: "click",
                ctr: "ctr",
                avgClickCost: "avg click cost",
                convert: "convert",
                convertCost: "convert cost",
                convertRate: "convert rate",
            },
            botton: {
                exportExcel: "Export Excel",
                viewChart: "View chart"
            }
        },
        // 广告产品
        product: {
            // 程序化创意
            creative: {
                adCreative: "ad creative",
                creativeStyle: "creative style",
                detailedData: "detailed data",
                subdivision: "subdivision",
                imageModeOptions: {
                    smallPicture: "small picture",
                    bigPicture: "big picture",
                    portrait: "portrait",
                    largePicture: "large picture",
                    photos: "photos",
                    GIFImage: "GIF image",
                    horizontalVideo: "horizontal video",
                    verticalVideo: "vertical video",
                    searchBigPicture: "search big picture",
                    searchThumbnail: "search thumbnail",
                    pangolinOpenPicture: "pangolin open picture",
                    pangolinOpenVideo: "pangolin open video",
                    title: "title",
                },
                detailOptions: {
                    none: "none",
                    placement: "placement",
                    promotionPurpose: "promotion purpose",
                    billingMethod: "billing method",
                    creativeStyle: "creative style",
                    createCreativeStyles: "create creative styles",
                    gender: "gender",
                    age: "age",
                    province: "province",
                    cityTOP20: "cityTOP20",
                    interestClassification: "interest classification",
                    platform: "platform",
                    theInternet: "the internet",
                    city: "city"
                },
                requiredCols: {
                    time: "time",
                    exploreStatus: "explore status",
                    creativity: "creativity",
                    account: "account",
                    adGroup: "ad group",
                    adPlan: "ad plan",
                    status: "status",
                    material: "material",
                    model: 'model'
                },
                warning: {
                    date: "under time-sharing conditions, the date range cannot exceed 7 days!"
                },

            },
            // 分素材统计
            material: {
                label: {
                    adPlan: "ad plan",
                    search: "search",
                    materialType: "material type",
                    remarks: "remarks",
                    modelLabel: "brand name",
                    brandLabel: "brand label",
                    policyLabel: "policy label",
                    contentTag: "content tag",
                    cost: "cost",
                    transfer: "transfer",
                    transferCost: "transfer cost",
                    show: "show",
                    material: "material",
                    materialID: "material ID",
                    accountID: "account ID",
                    date: "date",
                    createTime: "create time",
                    duration: "duration"
                },
                placeholder: {
                    materialName: "Material name or ID",
                    remark: "Search remark",
                },
                title: "detailed data",
                btns: {
                    downloadTable: "Download table"
                }
            },
            // 标签统计
            label: {
                requiredCols: {
                    labelID: "label ID",
                    labelName: "label"
                }
            }
        },
        live: {
            column: {
                addFan: 'add fan',
                addFanRate: 'add fan rate',
                addGroup: 'add group',
                addGroupRate: 'add group rate',
                avgPeople: 'avg people',
                avgPeopleSee: 'avg people see',
                dateStr: 'date',
                globalGmv: 'global GMV',
                gmv: 'conversion GMV',
                goodsChick: 'goods click',
                goodsChickRate: 'goods click rate',
                liveCostRmb: 'live cost rmb',
                liveLike: 'live like',
                maxPeople: 'max people',
                orderNum: 'order number',
                orderPeopleNum: 'order people number',
                orderRate: 'order rate',
                reply: 'reply',
                saleGoods: 'sale goods',
                salePrice: 'sale price',
                saleTopFirst: 'sale top first',
                saleTopSecond: 'sale top second',
                saleTopThird: 'sale top third',
                shareGoods: 'share goods',
                timeStr: 'duration',
                totalPeople: 'total people',
                account: 'account'
            }
        }
    },
    // advertiserSelector组件
    advertiserSelector: {
        placeholder: {
            account: "Please select an account",
            drag: "Please drag the material to the corresponding type"
        },
        text: "No data",
        loading: "loading..."
    },
    // reportCharPanel组件
    reportCharPanel: {
        bar: {
            legendFilterOptions: {
                top5: "Show Top5",
                top: "Show Top10",
                sum: "Show summary data"
            }
        },
        index: {
            cost: "cost",
            show: "show",
            avgShowCost: "avg show cost",
            click: "click",
            ctr: "ctr",
            avgClickCost: "avg click cost",
            convert: "convert",
            convertCost: "convert cost",
            convertRate: "convert rate",
            active: "active",
            register: "register",
            gameAddiction: "game addiction",
            comment: "comment",
            like: "like",
            share: "share",
            follow: "follow",
            homeVisited: "home visited",
            tabName: {
                trend: 'trend',
                proportion: 'proportion',
                compare: 'compare'
            }
        }
    },
    // ColumnSelector组件
    columnSelector: {
        btns: {
            customColumn: "custom column"
        },
        dialog: {
            columnName: "Search column name",
            addColumn: "Addable columns",
            selected: "",
            column: " columns selected"
        },
        activeParent: "Setting data"
    },
    // MaterialPiePanel组件
    materialPiePanel: {
        title: {
            top: "Label Proportion",
        },
        amountMaterial: "Amount of material"
    },
    //AudienceChartPanel组件
    audienceChartPanel: {
        area: {
            province: "Provincial distribution",
            city: "Prefecture-level city distribution",
        },
        title: {
            chart: "Audience chart",
            gender: "Sex distribution",
            age: "Age distribution",
            platform: "Platform distribution",
            tag: "Interest classification distribution",
            network: "Network distribution"
        },
        label: "Display indicators",
        indicatorFilterOptions: {
            cost: "cost",
            show: "show",
            avgShowCost: "avg show cost",
            click: "click",
            ctr: "ctr",
            avgClickCost: "avg click cost",
            convert: "convert",
            convertCost: "convert cost",
            convertRate: "convert rate",
        }
    },
    //cascader组件
    cascader: {
        firstLabel: "Level 1 label",
        secondLabel: "Level 2 label",
        thirdLabel: "Level 3 label",
    },
    //user页面
    user: {
        label: {
            normal: "normal",
            frozen: "freeze"
        },
        colunmn: {
            name: "User's Nickname",
            time: "Registration time"
        },
        actions: {
            edit: "edit",
            freeze: "freeze account",
            remove: "delete account",
        }
    },
    //noPermission页面
    noPermission: {
        logOut: "Back to login interface",
        tips: "Sorry, your account is not authorized. Please contact the administrator to resolve.",
        message: {
            success: "Logout successful",
            fail: "Logout failed, please try again later",
            error: "No accessible page routing"
        },
        //noFound页面
        noFound: {
            message: "Sorry, the page was not found",
            goBack: "Back to homepage",
            error: "Page not found"
        }
    },
    //audience_cols.js
    audienceCols: {
        name: "Performance index",
        sub: {
            name: {
                presentationData: "Presentation data",
                conversionData: "Conversion data",
                videoData: "Video data",
                interactiveData: "Interactive data",
            },
            label: {
                cost: "cost",
                show: "show",
                avgShowCost: "avg show cost",
                click: "click",
                ctr: "ctr",
                avgClickCost: "avg click cost",
                convert: "convert",
                convertCost: "convert cost",
                convertRate: "convert rate",
                deepConvert: "deep convert",
                deepConvertCost: "deep convert cost",
                deepConvertRate: "deep convert rate",

                totalPlay: "views",
                validPlay: "effective play count",
                validPlayRate: "effective playback rate",
                validPlayCost: "effective playback cost",
                play25FeedBreak: "25% progress playback",
                play50FeedBreak: "50% progress playback",
                play75FeedBreak: "75% progress playback",
                play100FeedBreak: "99% progress playback",

                playOverRate: "play over rate",
                averagePlayTimePerPlay: "average single play time",
                wifiPlayRate: "WiFi playback ratio",
                follow: "new followers",
                like: "likes",
                comment: "number of comments",
                share: "shares",
                homeVisited: "pageviews",

                iesChallengeClick: "challenge Views",
                iesMusicClick: "number of music views",
                locationClick: "POI hits",
            }
        }
    },
    // report_cols.js
    reportCols: {
        name: {
            conversionData_time: "Conversion data(Billing time)",
            appDownload: "App download advertising data",
            landingPage: "Landing page and store data",
            additionalIdeas: "Additional ideas",
            performanceIndex: "Performance index",
            settingData: "Setting data",
            propertySetting: "Property setting",
        },
        label: {
            // 转化数据(计费时间)
            convert_time: "convert(Billing time)",
            convertCost_time: "convert cost(Billing time)",
            deepConvert_time: "deep convert(Billing time)",
            deepConvertCost_time: "deep convert cost(Billing time)",
            // 应用下载广告数据
            downloadStart: "Android download start count",
            downloadStartCost: "Android download start cost",
            downloadStartRate: "Android download start rate",
            downloadFinish: "Android downloads completed",
            downloadFinishCost: "Android download completion cost",
            downloadFinishRate: "Android download completion rate",
            installFinish: "Android installation completed",
            installFinishCost: "Android installation completion cost",
            installFinishRate: "Android installation completion rate",
            active: "Activation number",
            activeCost: "Activation cost",
            activeRate: "Activation rate",
            register: "Number of registrations",
            activeRegisterCost: "Registration cost",
            activeRegisterRate: "Registration rate",
            gameAddiction: "Key behaviors",
            gameAddictionCost: "Critical behavior cost",
            gameAddictionRate: "Critical behavior rate",
            attributionNextDayOpenCnt: "Number of times",
            attributionNextDayOpenCost: "Secondary cost",
            attributionNextDayOpenRate: "Secondary retention",
            payCount: "Paid",
            activePayCost: "Paid cost",
            activePayRate: "Pay rate",
            inAppUv: "Access within the app",
            inAppDetailUv: "Visit the details page in the app",
            inAppCart: "Add to cart in APP",
            inAppOrder: "Place an order within the APP",
            inAppPay: "Pay in App",
            loanCompletion: "Number of completed",
            loanCompletionCost: "Finished cost",
            loanCompletionRate: "Completion rate",
            preLoanCredit: "Pre-credit",
            preLoanCreditCost: "Pre-credit cost",
            loanCredit: "Credits",
            loanCreditCost: "Credit cost",
            loanCreditRate: "Credit rating",
            // 落地页及门店数据
            phone: "Click the phone button",
            form: "Form submission",
            mapSearch: "Map search",
            button: "Button",
            view: "Key page browsing",
            download: "Download start",
            qq: "QQ Consulting",
            lottery: "lottery",
            vote: "vote",
            message: "SMS consultation",
            redirect: "Page jump",
            shopping: "Goods purchase",
            consult: "Online consultation",
            wechat: "WeChat copy",
            phoneConfirm: "Smart Phone-Confirm Call",
            phoneConnect: "Smart phone-confirm connection",
            consultEffective: "Effective consultation",
            coupon: "Station building card coupon collection",
            couponSinglePage: "Coupon page collection",
            // 附加创意
            advancedCreativePhoneClick: "Additional creative phone button click",
            advancedCreativeCounselClick: "Additional creative online consultation click",
            advancedCreativeFormClick: "Additional creative form button click",
            advancedCreativeCouponAddition: "Receive additional creative cards",
            // 设置数据
            toutiaoAdId: "Advertising Program ID",
            campaignName: "Ad group",
            toutiaoCampaignId: "Ad group ID",
        }
    },
    // navbar组件
    navbar: {
        name: "respected user",
        logOut: "sign out"
    },
    // request.js文件
    request: {
        message: "Your login has expired, you can cancel to stay on this page, or log in again",
        title: "Logout",
        confirmButtonText: 'Re login',
        cancelButtonText: 'Cancel',
        error: "Request timed out, please try again later"
    },
    // tableSelectMixin.js
    tableSelectMixin: {
        message: {
            materialChoose: "Maximum material selection",
            piece: "piece",
            customize: "customize",
            programmatic: "programmatic",
            creativityChoose: "Most creative choices",
        }
    },
    //TikTok
    tiktok: {
        // chartsRequest对象
        chartsRequest: {
            gender: 'gender',
            age: 'age',
            country: 'country',
            internet: 'internet',
            language: 'language',
            system: 'system',
            interestOrientation: 'interest orientation',
            placement: 'placement',
        },
        // audience_cols.js文件
        advertiserCols: {
            name: "Advertising audience",
            sub: {
                indexData: "Index data",
                clickCnt: "Hits",
                conversionCost: "Real-time conversion cost",
                conversionRate: "Real-time conversion rate",
                convertCnt: "Real-time conversions",
                ctr: "Click rate",
                showCnt:"Impressions",
                statCost:"Consume",
                timeAttrConvertCnt: "Conversions",
            }
        },
         // 组件
         component: {
            area: {
                title: {
                    country: "Country distribution",
                    audienceChart: "Audience chart",
                    genderDistribution: "Gender distribution",
                    ageDistribution: "Age distribution",
                    platformDistribution: "Platform distribution",
                    interest: "Interest classification distribution",
                    internet: "Network distribution",
                    language: "Language distribution",
                    placement: "Placement distribution",
                    label: "Percentage of labels",
                    modelLabel: "Brand name",
                    brandLabel: "Brand label",
                    policyLabel: "Policy label",
                    contentLabel: "Content label",
                }
            },
            indicatorFilterOptions:{
                statCost:"Consume",
                showCnt:"Impressions",
                clickCnt:"Hits",
                timeAttrConvertCnt:"Conversions",
                ac:"The internet",
                age:"Age",
                conversionCost:"Real-time conversion cost",
                conversionRate:"Real-time conversion rate",
                convertCnt:"Real-time conversions",
                country:"Vountry",
                ctr:"Click rate",
                gender:"Gender",
                interestCategory:"Primary interest orientation",
                language:"Language",
                placement:"Slot",
                platform:"Operating system",
            }
        }
    },
    modifyPass: {
        name: "change password",
        form: {
           oldPass: "old password",
           newPass: "new password",
           checkPass: "check password"
        },
        rules: {
            oldPass: "Please enter your old password",
            newPass: "Please enter a new password",
            enterAgain: "Please enter your password again",
            inconformityPass: "The two passwords do not agree"
        },
        message: {
            success: "Operation successful, please log in again",
        }
    },
    empower: {
        demand: {
           createBtn: 'new',
           model: {
            create: 'new',
            edit: 'edit',
            view: 'view',
            label: 'label',//标签
            review: 'check',//审核
            feedback: 'feedback',//反馈
            close: 'close order',//关闭订单
           },
           statusList: {
            new: 'new',//新建
            submitted: 'submitted',//已提交
            complete: 'complete',//完成
            error: 'error',//有误
            refuse: 'refuse',//拒绝
            update: 'update',//更新
          },
          typeList: {
            image: 'image',//图片
            video: 'video',//视频
            text: 'text',//文案
            complex: 'complex',//复合
            script: 'script',//脚本
            page: 'web page',//落地页
          },
           delete: 'Are you sure to delete this record?' ,//确认删除该记录？
           share: 'Are you sure to share this material? After sharing, the last sharing will become invalid.',//确定分享该素材？分享后，上次分享将失效。
           searchTips: 'Please enter the demand name',//请输入需求名称
           placeholder: {
            modelLabel: 'brand name',//请选择车型标签
            brandLabel: 'brand label',//请选择品牌标签
            policyLabel: 'policy label',//请选择政策标签
            contentTag: 'content label',//请选择内容标签
           },
           form: {
            name: 'demand name',//需求名称
            desc: 'description of Requirement',//需求描述
            case: 'reference case',//参考案例
            reference: 'customer profile',//客户资料
            account: 'account',//账户
            media: 'media',//媒体
            demandList: 'requirements list',//需求清单
            actor: 'actor',//演员
            label: 'global label',//全局标签
            principal: 'principal',//负责人
            expectedTime: 'expected completion time',//期望完成时间
            fileList: 'file list',//文件列表
            reason: 'reason',
            lookRelated: 'Just look related to me'
           },
           rules: {
            name: 'Please enter the requirement name',//请输入需求名称
            desc: 'Please enter the requirement description',//请输入需求描述
            case: 'Please select a reference case',//请选择参考案例
            reference: 'Please select a reference data',//请选择参考资料
            account: 'Please select an account',//请选择账户
            media: 'Please select media',//请选择媒体
            demandList: 'Please select the demand list',//请选择需求清单
            tag: 'Please select 4 global tags',//请选择全局标签
            principal: 'Please select the person in charge',//请选择负责人
            expectedTime: 'Please select the expected completion time',//请选择期望完成时间
           },
           column: {
            id: 'Demand number',//需求号
            name: 'Demand name',//需求名称
            expectedTime: 'Expected completion time',//期待完成时间
            gmtCreate: 'Submission time',//提交时间
            submiterName: 'Submitter',//提交者
            uploadTime: 'Upload time',//上传时间
            uploaderName: 'Uploaded by',//上传者
            type: 'type',//类型
            statusDesc: 'status',//状态
           },
           message: {
            leader: 'Please select the person in charge',//请选择负责人
            media: 'Please select the media first',//请先选择媒体
            tags: 'Please choose four labels',//请选择四种标签
           },
           hisColumn: {
            demandName: 'demand name',//需求名称
            tags: 'global label',//全局标签
            name: 'file name',//文件名
            content: 'content',//内容
            style: 'style',//类型
            size: 'size',//文件大小
            status: 'status',//状态
            media: 'media',//媒体
            resource: 'resource name',//素材名称
            number: 'resource number',//素材数量
            leader: 'resource leader',//素材负责人
            rule: 'resource rules',//素材规则
          },
          prompt: {
            check: 'check',//审核
            pass: 'pass',//通过
            noPass: 'no pass',//不通过
            reason: 'no pass, fill in the reason',//不通过，填写原因
            warn: 'Please fill in the reason',//请填写原因
            submitText: 'submitting...',//提交中...
         },
         detailTitle: 'demand details',//需求详情
         logColumn: {
            user: 'operator name',//操作员名称
            content: 'operation content',//操作内容
            time: 'operating time',//操作时间
            type: 'Operation type',//操作类型
         },
         closeOptions: {
            test: 'Test order',
            cancel: 'Demand cancelled',
            adjust: 'Adjust',
            other: 'Other'
          },
          logModalTitle: 'Cancellation record',
          logData: {
              type: 'Type of cancel order',
              reason: 'Cancel the reason'
          }
        },
        material: {
            type:{
                image:"image",
                video:"video",
                text:"text",
            },
            name: 'Material management',
            searchTips: {
                image: 'Please enter the picture name',//请输入图片名称
                video: 'Please enter the video name',//请输入视频名称
                text: 'Please enter the name of the copy',//请输入文案名称
                data: 'Please enter the file name',//请输入文件名称
            },
            label: {
                name:"name",
                state: "state",
                type: "type",
                customer: "customer",
                keyword:"keyword",
                videoLink:"Video association"
            },
            btns: {
                share: "share",
                delete: "delete",
                upload: "upload",
                move: "move",
                addFolder: 'Add Folder'
            },
            column: {
                // 图片
                picture: "picture/group pictures",
                pictureName: "Picture name",
                creationTime: "Creation time",
                updateTime: "Update time",
                creator: "creator",
                pictureType: "Picture type",
                size: "size",
                demandNumber: "Demand number",
                state: "state",
                operation: "operation",
                // 视频
                video: "video",
                videoType: "Video type",
                videoName: "Video name",
                cover: "cover",
                // 文案名
                copyName: "Copy name",
                copyContent: "Copy content",
                // 脚本
                scriptName: "Script name",
                scriptDescription: "Description",
                // 资料库
                fileName: "file name",
                type: "type",
                keyword: "keyword",
                model: "model",
                customer: "customer",
                content:"content",
                thumbnail:"thumbnail",
                preview:"preview",
                // 脚本
                scriptName:"Script name",
                type:"type",
                //落地页
                screenshot: "landing page",
            },
            operation:{
                edit: "edit",
                delete: "delete",
                share: "share",
                feedback: "feedback",
                view: "view",
                download:"download",
                move: 'move'
            },
            ruler:{
                demandNumber:"No demand number selected",
                media:"No media selected",
                pictureType:"No picture type selected",
                videoType:"No video type selected",
                textType:"No copy type selected",
                cover:"Cover not uploaded",
                keyword: "No keywords entered",
                name: "No name entered",
                sName: "Script name not entered",
                content: "No input",
                model: "No model selected",
                customer: "No customer selected",
                type:"No type selected",
                content: "No content entered",
                gImg1:"Please upload",
                gImg2:"pictures",
            },
            dialog:{
                demandNumber:"Demand number",
                media:"media",
                pictureType:"Picture type",
                videoType:"Video type",
                textType:"Text type",
                cover:"cover",
                type:"type"
            },
            confirm:{
                 IMAGE:"Please select the picture type before uploading!",
                 VIDEO:"Please select the video type before uploading!",
                 TEXT:"Please select the copy type before uploading!",
                 SCRIPT: "Please select the script type before uploading!",
                data:"Please select the data type before uploading!",
                uploadSize:"The upload file size is incorrect!",
                uploadFormat:"The upload file format is incorrect!",
                file:"File not uploaded!",
                selected:"No data selected!",
                cover:"Cover not uploaded!",
                excel: "Choose Excel file to upload",
                excelError: "Upload failed, please confirm whether the content of the file is correct!",
                waitUpload:"Please wait for the file upload to complete!",
                gImg:"Please upload the correct number of pictures!",
                waitUpload:"Please wait for the file upload to complete!"
            },
            status: {
                init: 'initialization',//初始化
                complete: 'complete',//完成
                refuse: 'refuse',//拒绝
                error: 'error'//有误
            },
            message: {
                size: 'Landing page size cannot exceed 20M',//截图大小不能超过20M
                requireUrl: 'Please enter the landing page link',
                errorUrl: 'Link format error',
                tpltips: 'Click to download and upload the template',//点击下载上传模板
            }
        },
        materialData:{
            label:{
                account:"account",
                type :"type",
                time:"time",
                label:"label",
                timeGranularity:"time granularity"
            },
            column:{
                account:"account",
                time :"time",
                label :"label",
                totalMaterials :"Total materials",
                totalNumberOfOnlineMaterials :"Total number of online materials",
            }
        },
        mediaManage: {
            filterForm: {
                all: 'All'
            },
            status: 'status',
            mediaName: 'media name',
            description: 'description',
            unfreeze: 'unfreeze',
            freezeConfirm: 'Confirm to freeze this media?',
            unfreezeConfirm: 'Confirm to unfreeze this media?',
            deleteConfirm: 'Confirm to delete this media?',
            rules: {
                mediaName: "Please enter a media name",
                mediaNameLength: "1 to 50 characters in length",
            }
        },
        materialConfig: {
            formLabel: {
                media: 'media',
                type: 'type',
                status: 'status',
                toutiao: 'toutiao type',//效果通类型
            },
            placeholder: {
                media: 'Please select a media',
                type: 'Please select a type',
                status: 'Please select a status',
                len: 'Letter, number and Space is half a character ',
                format: 'Please select a format',
                keyword: 'Please enter the material name',//请输入素材名称
            },
            column: {
                name: 'name',
                description: 'description',
                type: 'type',
                rules: 'rules',
                media: 'media',
                status: 'status',
                text: 'text', // cherry
            },
            form: {
                name: 'name',
                description: 'description',
                media: 'media',
                type: 'type',
                format: 'format',
                videoRate: 'video rate',
                audioRate: 'audio rate',
                duration: 'duration',
                dim: 'resolution',
                resolution: 'resolution',
                width: 'width',
                height: 'height',
                ratio: 'aspect ratio',
                size: 'size',
                len: 'length',
                gImg:"whether to group pictures",
                count:"number of pictures"
            },
            rules: {
                name: "Please enter a name",
                nameLength: "1 to 50 characters in length",
                media: 'Please select a media',
                type: 'Please select a type'
            }
        },
        actor: {
            deleteBtn: 'delete',//删除
            form: {
                name: 'name',//姓名
                gender: 'gender',//性别
                birth: 'birth',//出生
                height: 'height',//身高
                weight: 'weight',//体重
                measurements: 'measurements',//三围
                price: 'price',//报价区间
                image: 'image',//形象
                work: 'work',//作品
                appearance: 'appearance',//属性
            },
            column: {
                name: 'name',//姓名
                image: 'image',//形象
                gender: 'gender',//性别
                birth: 'birth',//出生
                height: 'height',//身高
                measurements: 'measurements',//三围
                price: 'price',// 报价区间
                updateTime: 'updateTime',//更新时间
                updater: 'updater',//更新人
                status: 'status',//状态
            },
            title: {
                info: 'Personal information',//个人信息
                work: 'Work',//作品
                effect: 'Work effect',//作品投放效果
            },
            detailColumn: {
                id: 'id',//素材ID
                image: 'image',//素材缩略图
                cons: 'consume',//消耗
                impressions: 'impressions',//impressions
                hits: 'hits',//点击数
                clickRate: 'clickRate',//点击率
            },
            confirm: {
                freeze: 'Determine to freeze the actor',//确定冻结该演员
                unfreeze: 'Determine to unfreeze the actor',//确定解冻该演员
            },
            success: {
                freeze: 'Freeze successfully',//冻结成功
                unfreeze: 'unFreeze successfully',//解冻成功
            },
            message: {
                noRecord: 'Please select a record',//请选择一条记录
                name: 'Please enter name',//请输入姓名
                gender: 'Please select gender',//请选择性别
                tall: 'Please enter height',//请输入身高
                tallError: 'Tall must be a positive integer',//身高必须是正整数
                weight: 'Please enter weight',//请输入体重
                weightError: 'Weight is a positive number, with up to two decimal places',//体重是正数，最多保留两位小数
                measurements: 'Please enter the measurements',//请输入三围
                measurementsError: 'The measurement format must be: 90-80-70',//三围格式必须是：90-80-70
                price: 'Please enter the price',//请输入价格
                priceError: 'The price is a positive number, with up to two decimal places',//价格是正数，最多保留两位小数
                priceError2: 'The price on the left cannot be higher than the price on the right',//左侧价格不能高于右侧价格
                cover: 'Please upload an image',//请上传形象照
                upload: 'Only upload pictures or video files',//只能上传图片或视频文件
                appearance: 'Please select appearance',//请选择属性
            },
            searchTips: {
                tall: 'Please enter height',//请输入身高
                keyword: 'Please enter the name of the actor',//请输入演员姓名
            },
            appearance: {
                young: 'young',//年轻
                mature: 'mature',//偏成熟
                middle: 'middle-aged',//中老年
                child: 'child',//儿童
            }
        },
        resources: {
            tab: {
                actor: "actor library",
                props: "props library",
                scene: "scene library",
            },
            form: {
                name: 'name',
                gender: 'gender',
                age:"age",
                style:"style",
                attribute:"attribute",
                price: 'price',
                height: 'height',
                history:"history",
            },
            btns:{
                apply:"external actor application",
                review:"application review",
                reservation:"reservation"
            },
            column: {
                name: 'name',
                image: 'image',
                gender: 'gender',
                birth: 'birth',
                age:"age",
                style:"style",

                height: 'height',
                measurements: 'measurements',
                price: 'price',
                attribute:"attribute",
                history:"cooperation history",


                updateTime: 'update time',
                updater: 'updater',
                status: 'status'
            },
            confirm: {
                freeze: 'Determine to freeze the actor',//确定冻结该演员
                unfreeze: 'Determine to unfreeze the actor',//确定解冻该演员
            },
            success: {
                freeze: 'Freeze successfully',//冻结成功
                unfreeze: 'unFreeze successfully',//解冻成功
            },
            applyForm:{
                name:"project name",
                type:"actor type",
                count:"number of recorded videos",
                location:"filming locations",
                date:"shooting time",
                demand:"clothing requirements",
                remark:"remark",
            },
            review:{
                title:"Application list",
                date:"application submission time",
                type:"application type",
                actor:"apply for actors",
                name:"project name",
                person:"applicant",
                status:"status",
                operating:"operating",
                review:"review",
                view:"view",
            },
            table:{
                date:"application time",
                person:"applicant",
                actor:"appointment actors",
                refuse:"refuse",
                pass:"pass",
                title1:"External actors apply for review",
                title2:"Appointment actor application review",
            },
            reservation:{
                title:"Appointment application",
                actor:"actor",
                date:"time selection"
            },

        },
        template:{
            searchTips: {
                design: 'Please enter the design name',// 请输入设计名称
                video: 'Please enter the video name' // 请输入视频名称
            },
            label: {
                industry:"industry", // 行业
            },
            btns: {
                share: "share",
                delete: "delete",
                upload: "upload",
                batchDelete: "batch delete",
                batchPass: "batch pass"
            },
            ruler:{
                type:"No type selected",
                industry:"No industry selected",
                relatedResource: "No Related Resource selected",
                typeOrIndustry: 'Type and industry must choose one',
            },
            dialog:{
                videoName:"Video name", // 视频名称
                designName:"Design name", // 设计名称
                downloadVideo: "Download video", // 下载视频
                downloadProject:"Download project file", // 下载工程视频
                downloadPSD: "Download PSD", // 下载PSD
                downloadPNG: "Download PNG", // 下载PNG
                relatedDesign: "Related design", // 相关设计
                relatedVideo: "Related video", // 相关视频
                uploadVideo: " video", // 视频
                uploadProject: " Project file", // 工程文件
                materialID: "Material ID", // 素材ID
                recentlyEdited: "Recently edited", // 最近修改者
                lastModifiedTime: "Last modified time", // 最近修改时间
                size: "Size", // 大小
                tags: "Tags", // 标签
                duration: "duration", // 时长
                pixel: "pixel", // 尺寸
            },
            sort: {
                lastTime: "Last modified time", // 最近修改时间最近优先
                download: "Most downloaded", // 下载次数最多优先
                mostResource: "Most connected resources", // 关联资源数量最多优先
            },
            message: {
                requireName: "Please enter the name", // 请输入名称
                requireType: "Please select a type", // 请选择类型
                requireIndustry : "Please select a industry", // 请选择行业
                requireResource: "Please select related resource", // 请选择关联资源
                requireFile: "Please upload files", // 请上传文件
                chooseTips: "No data selected!", // 未选中数据
                generateZero: "Generate 0 content", // 生成0条内容
            }
        }
    },
    share: {
        title: 'share',
        copyImg: 'Right-click on the QR code and select duplicate qr code',
        copySuccess: 'Copy successfully'
    },
    message: {
        msg: 'message',//消息
        column: {
            title: 'title',//标题
            status: 'status',//状态
            time: 'time',//时间
        },
        btns: {
            read: 'read',//标记为已读
            unread: 'unread',//未读
        },
        message: {
            read: 'Marked as read',//已标记为已读
            delete: 'Are you sure to delete this message?',//确定删除该消息？
            allRead: 'Are you sure to mark the selected message as read?',//确定将选中的消息标记为已读吗
            allDelete: 'Are you sure to delete the selected message?',//确定删除选中的消息吗
        }
    },
    secondWeb: {
        video: {
           column: {
               id: 'id',//记录ID
               filename: 'fileName',//文件名
               imageUrl: 'imageUrl',//封面
               fileUrl: 'fileUrl',//视频
               size: 'size',//大小
               uploader: 'uploader',//上传者
               gmtCreate: 'uploaderTime',//上传时间
           },
           form: {
                content: 'content',//水印内容
                size: 'font size',//字体大小
                color: 'font color',//文字颜色
                position: 'position',//文字位置
                time: 'appearance time',//水印出现时间
                bg: 'backgrouond',//背景颜色
                opacity: 'opacity',//背景透明度
                weight: 'font weight',//字体粗细
                family: 'font family',//字体
           },
           message: {
               formatErr: 'Please upload the correct video format',//请上传正确的视频格式
               sizeErr: 'Upload video size exceeds 50MB',//上传视频大小超过50MB
               nameErr: 'Please enter the correct video file name',//请输入正确的视频文件名
               content: 'Please enter the watermark content',//请输入水印内容
               color: 'Please select text color',//请选择文字颜色
               uploadWarning: 'Only upload video files, and no more than 50M',//只能上传视频文件，且不超过50M
               showTime: 'Show in seconds',//第几秒开始显示
               bg: 'Please choose background color',//请选择背景颜色
           },
           opacityList: {
                opaque: 'opaque',//不透明
                transparent: 'Fully transparent',//全透明
            },
            fontFamilyList: {
                Yahei: 'Microsoft YaHei',//微软雅黑
                SimSun: 'SimSun',//宋体
                SimHei: 'SimHei',//黑体
                JhengHei: 'Microsoft JhengHei',//微软正黑体
                KaiTi: 'KaiTi',//楷体
                NSimSun: 'NSimSun',//新宋体
                FangSong: 'FangSong',//仿宋
                PingFang: 'PingFang SC',//苹方
                STHeiti: 'STHeiti',//华文黑体
                STKaiti: 'STKaiti',//华文楷体
                STSong: 'STSong',//华文宋体
                STFangsong: 'STFangsong',//华文仿宋
                STZhongsong: 'STZhongsong',//华文中宋 
                STHupo: 'STHupo',//华文琥珀
                STXinwei: 'STXinwei',//华文新魏
                STLiti: 'STLiti',//华文隶书
                STXingkai: 'STXingkai',//华文行楷
           },
           fontWeight: {
                normal: 'Normal',
                bold: 'Bold'
            } 
        }
    },
    wechat:{
        bind:"Bind to WeChat",
        sacnCode:"Scan code to bind WeChat",
        unbind:"Unbind WeChat",
        message:"Do you want to unbind WeChat?",
        unBindSuccess:"WeChat binding has been lifted!",
        bindSuccess:"WeChat binding successfully!"
    },
    campaign: {
        label: {
            infinite: 'Infinite',
            specify: 'Specify budget',
            total: 'total budget',//总预算
            budget: 'daily budget',//日预算
            selectType: 'Please select the type of promotion purpose',//请选择推广目的类型
            name: 'Please enter the campaign name',//请输入广告组名称
            campaignName: 'campaign name',//广告组名称
            campaignBudget: 'campaign budget',//广告组预算
            deliveryRelatedNum: 'campaign product type',//广告组商品类型
            NDPA: 'campaign DPA default not',//非DPA
            SDPA: 'campaign DPA single delivery',//SDPA 单商品推广
            DPA: 'campaign DPA multi delivery',//DPA 商品推广
            carModel: 'car model',
            advertiserName: 'advertiser name',//广告主名称
        },
        message: {
            name: 'Campaign name cannot be empty',//广告组名称不能为空
            budgetFormat: 'The budget supports up to two decimal places',//预算最多支持两位小数
            budgetLimit: 'Budget, not less than 300.00 yuan, not more than 9,999,999.99 yuan',//预算，不低于300.00元，不超过9,999,999.99元
            budgetEmpty: 'Please enter the campaign budget, no less than 300.00 yuan, no more than 9,999,999.99 yuan',//请输入广告组预算，不低于300.00元，不超过9,999,999.99元
            carModel: 'Please select the car model',
        },
        landingType: {
            APP: {
                title: 'Application promotion',//应用推广
                info: 'Improve application download, installation, activation, and payment',//提升应用的下载、安装、激活、付费
            },
            LINK: {
                title: 'Sales Lead Collection',//销售线索收集
                info: 'Improve the acquisition of sales leads',//提升销售线索的获取量
            },
            AWEME: {
                title: 'Douyin Promotion',//抖音号推广
                info: 'Increase the number of fans and interactions of Douyin',//提升抖音号的粉丝量、互动量
            },
            STORE: {
                title: 'Store promotion',//门店推广
                info: 'Improve the effect of offline stores',//提升线下门店的到店效果
            },
            SHOP: {
                title: 'E-commerce store promotion',//电商店铺推广
                info: 'Increase product sales in e-commerce stores',//提升电商店铺的产品销量
            },
            DPA: {
                title: 'Product catalog promotion',//
                info: 'Improve product catalog exposure and click',//提升产品目录的曝光与点击
            },
            GOODS: {
                title: 'Product promotion',//商品推广
                info: 'Improve product exposure and clicks',//提升商品的曝光与点击
            },
        },
        column: {
            name: 'name',//广告组名称
            target: 'target',//推广目的
            type: 'Product types',//商品类型
            budget: 'budget',//预算
            carModel: 'car model',//关联车型
            create: 'create time',//创建时间
            operation: 'operation type',//操作类型
            batchNo: 'push batch',//推送批次
            pushStatus: 'push status',//推送状态
        }
    },
    carModel: {
        column: {
            id: 'model id',//车型ID
            carModelName: 'model name',//车型名称
            advertiserGroupName: 'advertiser group name',//客户名称
            carModelCode: 'model code',//车型代码
            gmtCreate: 'create time',//创建时间
        },
        placeholder: {
            advertiserGroupIds: 'Please select a customer account',//请选择客户账号
            carModelName: 'Please enter the model name',
            carModelCode: 'Please enter the model code',
            advertisers: 'Please select a advertiser',
            campaign: 'Please select a campaign',
        },
        label: {
            advertisers: 'advertiser',
            toutiaoCampaignIds: 'campaign',
            keyword: 'keyword'
        },
        message: {
            warn:'Choose at least one'
        },
        title: 'Campaign binding model',//广告组绑定车型
    },
    board: {
        today: "Today's data", //今日数据
        timeStr: 'update time', //数据更新时间
        score: 'Personal rating', //个人评分    
        demandNum: 'Completed demands', //完成需求数
        resourceNum: 'Completed materials', //完成素材数
        demandNum2: 'Number of demands', //需求数
        resourceNum2: 'Number of materials', //素材数
        demandDoing: 'Ongoing demands', //进行中需求
        resourceDoing: 'Ongoing materials', //进行中素材
        avgDifficulty: 'Average difficulty of demand', //需求平均难度
        avgCompletionTime: 'Average material completion days', //平均素材完成天数
        demandList: 'Demand list',
        resourceList: 'Material list',
        completionTime: 'Completion time distribution',
        styleProportion: 'Proportion of material type',
        materialType: 'Material type',
        materialSubType: 'Material sub type',
        demandAndChart: 'Individual ongoing demand & material quantity trend chart',
        statusOptions: {
            processing: 'processing',
            completed: 'completed'
        },
        dateOptions: {
            15: 'Nearly 15 days',
            30: 'Nearly 30 days',
            90: 'Nearly 90 days',
            180: 'Nearly 180 days',
            365: 'Nearly 365 days'
        },
        resourceTypeOptions: {
            image: 'IMAGE',
            video: 'VIDEO',
            text: 'TEXT',
            script: 'SCRIPT',
            webpage: 'WEBPAGE'
        },
        columns: {
            demandName: 'Demand name',
            totalResourceCount: 'Demand materials',
            personalResourceCount: 'Personally responsible materials',
            costProportion: 'Proportion of material consumption',
            avgDifficulty: 'Average difficulty',
            avgCompletionDays: 'Average number of days completed',
            demandStatus: 'Demand status',
            materialCount: 'Number of material',
            imageCount: 'Number of image',
            videoCount: 'Number of video',
            textCount: 'Number of text',
            scriptCount: 'Number of script',
            locationCount: 'Number of location',
            completionDays: 'Complete days',
            userName: 'User name',
            completionDemand: 'Complete demand count',
            completionResource: 'Complete resource count',
            resourceStyleName: 'Demand for the material',
            resourceDifficulty: 'Material difficulty',
            resourceStatus: 'Material status'
        },
        more: 'or more',
        summary: 'Demand data summary',
        demandSum: 'Demand Number',
        resourceSum: 'Material number finished',
        avgDifficultySum: 'Total mean difficulty',
        personalDetail: 'Personnel details',
        personalName: 'Please enter the name of the person',
        export: 'Export excel',
        finishType: 'Complete material type',
        finishSubType: 'Complete material subtype',
        finishProportion: 'Percentage of completed material types'
    },
    templateIcon: {
        label: {
         libType: 'library',
         tag: 'label',
         parent: 'parent name',
         tagName: 'label name',
        },
        searchText: 'Please enter the label name',
        option: {
            industry: 'industry',
            kind: 'type',
            text: 'text library',
            design: 'design library',
            video: 'video library'
        } 
    },
    setCopyWriting: {
        btn: {
            createText: 'create text',
            createType: 'create type'
        },
        label: {
            type: 'type',
            pattern: 'pattern',
            part: 'part of the',
            name: 'name',
            model: 'input model',
            label: 'label',
            typeName: 'type name'
        },
        placeholder: {
            searchText: 'Please enter the pattern name',
            industry: 'Please select industry',
            type: 'Please select type',
            pattern: 'Please add pattern',
            labelName: 'Please select label',
            tagName: 'Please enter a label name',
            libType: 'Please select the library'
        },
        option: {
            manual: 'manual',
            manualAuto: 'manual & automatic'
        }
    },
    copywriting: {
        textLink: 'generate text link online',
        label: {
            selectText: 'sentence selection',
            batchCreate: 'mass production',
            generateCon: 'generate content',
            autoGenerate: 'automatic generated',
            serial: 'serial number',
            textEdit: 'edit text link',
            importText: 'import text',
            fileWarn: 'Only excel files can be uploaded, and no more than 10MB',
            editor: 'editor',
            editTime: 'edit time',
            enterCon: 'fill in the content',
            emptyWarn: 'The manual input part cannot be empty',
            selectTextWarn: 'Please select sentence first',
            textEmptyWarn: 'Please enter the sentence content',
            wordRange: 'word range',
            generateNum: 'generate number',
        },
        rules: {
            WordInteger: 'The word range must be a positive integer',
            wordError: 'The start value of the word range cannot be greater than the end value',
            wordEmpty: 'The word range cannot be empty',
            countInteger: 'The generated quantity must be a positive integer',
            countEmpty: 'The generated quantity cannot be empty'
        }
    },
    folder: {
        emptyErr: 'The destination folder cannot be empty'
    }
}